import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Hero banner for Darknet Research showcasing insights into dark web threats" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Darknet Research</p>
        <h1>Stay Ahead of Dark Web Threats.</h1>
        <p className="lede">
          Expert analysis and research to fortify your cybersecurity strategies.
        </p>
      </header>

      <section className="cards">
        <h2>In-Depth Dark Web Insights</h2>
        <p>
          Explore comprehensive research on emerging cyber risks and vulnerabilities from the dark web. Our white papers, case studies, and reports provide critical insights for cybersecurity professionals.
        </p>
        <button className="cta-button">Access Our Research</button>
      </section>
    </div>
  );
}

export default App;